import { useState } from "react";
import {
  Grid,
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";
import {
  ArrowForwardIos,
  Update,
  Close,
  EmojiEvents,
  Warning,
  Send,
} from "@mui/icons-material";
import { CustomIconsPlusText } from "../../../../Components/Common/Design/CustomIconsPlusText";
import Swal from "sweetalert2";
import DatePicker from "../../../../Components/Common/Inputs/DatePicker";
import { CustomButtonPlusIcon } from "../../../../Components/Common/Design/CustomButtonPlusIcon";

const UpdateCase = ({
  nextTask,
  dataCase,
  lastStep,
  activeFlow,
  activeTask,
  isLastFlowStep,
}) => {
  const [updateCaseDate, setUpdateCaseDate] = useState();
  const [changeRevisionState, setChangeRevisionState] = useState([]);
  const changeRevisionStateData = [
    // {
    //   name: "Actualizar",
    //   value: 0,
    //   icon: Update,
    //   color: "primary",
    //   hiddenByStatus: true,
    // },
    {
      name: "Pasar a siguiente tarea",
      value: 1,
      icon: ArrowForwardIos,
      color: "info",
      hiddenByStatus: isLastFlowStep,
    },
    {
      name: "Cancelar tarea",
      value: 2,
      icon: Warning,
      color: "warning",
      hiddenByStatus: isLastFlowStep,
    },
    {
      name: "Cerrar Caso",
      value: 4,
      icon: Close,
      color: "error",
    },
    // {
    //   name: "Caso ganado",
    //   name2: "Proceso NO Finalizado",
    //   value: 5,
    //   icon: EmojiEvents,
    //   icon2: Warning,
    //   color: "success",
    //   color2: "info",
    // },
    {
      name: "Caso Ganado",
      value: 3,
      icon: EmojiEvents,
      color: "info",
    },
  ];

  const handleUpdateCase = () => {
    if ([0, 1, 2, 3, 4, 5].includes(changeRevisionState?.value)) {
      Swal.fire({
        title: "¿Continuar con el proceso?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Sí",
        denyButtonText: "Volver",
      }).then((result) => {
        if (result.isConfirmed) {
          if (changeRevisionState?.value == 0) {
            // console.log("Actualizar");
          } else if (changeRevisionState?.value == 1) {
            nextTask(activeTask?.config, 1, "next", "");
          } else if (changeRevisionState?.value == 2) {
            nextTask(activeTask?.config, 2, true, "");
          } else if (changeRevisionState?.value == 3) {
            nextTask(activeTask?.config, 3, "lastone", "");
          } else if (changeRevisionState?.value == 4) {
            nextTask(activeTask?.config, 4, "lastone", "");
          } else if (changeRevisionState?.value == 5) {
            nextTask(activeTask?.config, 5, "lastone", "");
          }
          // console.log(changeRevisionState?.name);
        }
      });
    } else {
      Swal.fire({
        title: "Atención",
        text: "Debes seleccionar una opción antes de continuar.",
        icon: "info",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Entendido",
      });
    }
  };

  return (
    <Grid
      container
      item
      xs={12}
      sx={{
        "& > *": { padding: "10px", color: "#2e7d32" },
        border: "1px dashed #f4f9ff",
        background: "rgb(249 255 249)",
      }}
    >
      <Grid item xs={12} sx={{ background: "#2e7d32", textAlign: "center" }}>
        <b style={{ color: "white" }}>ACTUALIZAR CASO</b>
      </Grid>
      <Grid container item xs={6} gap={"10px"}>
        <Grid item xs={12} sx={{ padding: "10px" }}>
          <FormControl component="fieldset" width={"100%"}>
            <FormLabel
              component="legend"
              sx={{ fontSize: "14px", fontWeight: "700" }}
            >
              Estado:
            </FormLabel>
            {changeRevisionStateData.map((option, index) => {
              if (option.hiddenByStatus) {
                if (
                  dataCase?.task?.status == 1 ||
                  activeFlow?.order < dataCase?.flow?.order ||
                  (isLastFlowStep && option.value == 1)
                ) {
                  return null;
                }
              }

              return (
                <FormControlLabel
                  key={`${option.value}-${option.name}-${index}`} // 🔑 clave única y estable
                  control={
                    <Checkbox
                      checked={changeRevisionState.name === option.name}
                      onChange={() => setChangeRevisionState(option)}
                      value={option.value}
                      name={option.name}
                      color={option.color}
                    />
                  }
                  label={
                    <div style={{ display: "flex", gap: "10px" }}>
                      <CustomIconsPlusText
                        icon={option.icon}
                        severity={option.color}
                        styles={{
                          width: "15px",
                          height: "15px",
                        }}
                        text={option.name}
                      />
                      {option.name2 && (
                        <CustomIconsPlusText
                          icon={option.icon2}
                          severity={option.color2}
                          styles={{
                            width: "15px",
                            height: "15px",
                          }}
                          text={option.name2}
                        />
                      )}
                    </div>
                  }
                />
              );
            })}
          </FormControl>
        </Grid>
      </Grid>
      <Grid container item xs={6} gap={"10px"}>
        <Grid item xs={12} sx={{ padding: "10px" }}>
          <DatePicker
            text="Actualizar fecha de contador"
            date={dataCase?.task?.date_end}
            onChange={(newValue) => {
              setUpdateCaseDate(newValue);
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{ padding: "10px" }}>
          <FormControl sx={{ width: "100%" }}>
            <FormLabel htmlFor="maittoclientbody" style={{ fontSize: "14px" }}>
              Mensaje para cliente
            </FormLabel>
            <textarea
              name="maittoclientbody"
              id="maittoclientbody"
              rows="10"
              style={{
                width: "99%",
                fontSize: "14px",
                border: "1px solid rgba(128, 128, 128, 0.35)",
                background: "transparent",
              }}
            ></textarea>
          </FormControl>
        </Grid>
      </Grid>
      {activeFlow?.order == dataCase?.flow?.order && (
        <>
          <Grid item xs={12} py={"10px"}>
            <Divider width={"100%"} />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "end" }}>
            <CustomButtonPlusIcon
              handleFunction={handleUpdateCase}
              text={"Aceptar"}
              icon={Send}
              position={"end"}
              variant={"contained"}
              color={"success"}
              size={"small"}
              classes={"noClass"}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default UpdateCase;
